module.exports = __webpack_public_path__ + "img/policy.0aa6b76f.png";